/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {SettingsSelectionPage} from "../modules/settings-selection/SettingsSelectionPage";
import {DynamicBuilderRoute} from "./DynamicBuilderRoute";
import {ApplicationConfigurationProvider} from "../modules/application-configuration/core/ApplicationConfiguration";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
    const {currentUser, requireSettingsSelection} = useAuth()

    const requiresSettingsPage = requireSettingsSelection()

    return (
        <BrowserRouter basename={PUBLIC_URL}>
            <Routes>
                <Route element={<App/>}>
                    <Route path='error/*' element={<ErrorsPage/>}/>
                    <Route path='logout' element={<Logout/>}/>
                    {currentUser ? (
                        requiresSettingsPage
                            ? (<>
                                <Route path='select-settings/*' element={<SettingsSelectionPage/>}/>
                                <Route path='*' element={<Navigate to='/select-settings'/>}/>
                            </>)
                            : (<>
                                <Route path='/*' element={<ApplicationConfigurationProvider><DynamicBuilderRoute/></ApplicationConfigurationProvider>}/>
                                <Route index element={<Navigate to='/dashboard'/>}/>
                            </>)
                    ) : (
                        <>
                            <Route path='auth/*' element={<AuthPage/>}/>
                            <Route path='*' element={<Navigate to='/auth'/>}/>
                        </>
                    )}
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export {AppRoutes}
